module.exports = __webpack_public_path__ + "static/promo-text-no-user-810edeb692357752cc598691f796c9e9.svg";